module.exports = __webpack_public_path__ + "img/new-ranks-hero.80d4100b.png";